import React from 'react'

export const newHampshireSetupVars = {
  siteId: 'new_hampshire',
  pathPrefix: '/nh',
  menuHeader: "Discover New Hampshire's Solution for:",
  appUrl: 'https://nh.headed2.com',
  logoImg: '/images/assets/new_hampshire/horizontal/dark.svg',
  headerTitle: `The New Hampshire CareerExplorer is a system designed for New Hampshire`
}
